/* @index('./*.ts', f => `export * from '${f.path}';`) */
export * from './safe.module';
export * from './safe.pipe';
/* @endindex */
